import React from "react";
import Modal from "react-bootstrap/Modal";

import styles from '../styles.module.css'

const Loading = (props) => {

    return(
        <Modal show={props.show} centered contentClassName={styles['spinner-modal']}> 
            <Modal.Body style={{ 'textAlign':'center' }}>
                <svg width='100px' height='100px' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" className="uil-ring-alt">
                    <rect x="0" y="0" width="100" height="100" fill="none" className="bk"></rect>
                    <circle cx="50" cy="50" r="40" stroke="#f5f5f6" fill="none" strokeWidth="10" strokeLinecap="round"></circle>
                    <circle cx="50" cy="50" r="40" fill="none" strokeWidth="6" strokeLinecap="round" className={styles['spinner-color']}>
                        <animate attributeName="stroke-dashoffset" dur="2s" repeatCount="indefinite" from="0" to="502"></animate>
                        <animate attributeName="stroke-dasharray" dur="2s" repeatCount="indefinite" values="150.6 100.4;1 250;150.6 100.4"></animate>
                    </circle>
                </svg>
            </Modal.Body>
        </Modal>
    )
}

export default Loading;